import { Routes, Route, Navigate } from 'react-router-dom'
import { Layout } from './components/Layout'
import { LoginPage } from './pages/LoginPage.js'
import { ProtectedRoute } from './components/ProtectedRoute.js'
import { DashboardPage } from './pages/DashboardPage'
import { SettingsPage } from './pages/SettingsPage'
import { UnifiedNotebookPage } from './pages/UnifiedNotebookPage'
import { SolutionsBuilderPage } from './pages/SolutionsBuilderPage'
import { SolutionKnowledgeBasePage } from './pages/SolutionKnowledgeBasePage'
import { KgBrowserPage } from './pages/KgBrowserPage'
import { CouncilPage } from './pages/CouncilPage'
import { SkillsCatalogPage } from './pages/SkillsCatalogPage'
import { TrackerPage } from './pages/TrackerPage'
import { BriefingsPage } from './pages/BriefingsPage'
import { PunchListPage } from './pages/PunchListPage'
import { TechEvalsPage } from './pages/TechEvalsPage'
import { MindMapPage } from './pages/MindMapPage'
import { SafeReviewPage } from './pages/SafeReviewPage'
import { ConsciousnessPage } from './pages/ConsciousnessPage'
import { BetaFeedbackPage } from './pages/BetaFeedbackPage'
import { EditorPage } from './pages/EditorPage'
import { AudiobookPage } from './pages/AudiobookPage'
import { VoiceCloningPage } from './pages/VoiceCloningPage'
import { ThemeProvider } from './contexts/ThemeContext'
import { GlobalSearchDialog } from './components/GlobalSearchDialog'

function App() {
  return (
    <ThemeProvider>
    <GlobalSearchDialog />
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
        <Route index element={<DashboardPage />} />
        <Route path="notebook" element={<UnifiedNotebookPage />} />
        <Route path="solutions" element={<SolutionsBuilderPage />} />
        <Route path="solutions/knowledge-base" element={<SolutionKnowledgeBasePage />} />
        <Route path="knowledge-graph" element={<KgBrowserPage />} />
        <Route path="council" element={<CouncilPage />} />
        <Route path="skills" element={<SkillsCatalogPage />} />
        <Route path="mind-map" element={<MindMapPage />} />
        <Route path="tracker" element={<TrackerPage />} />
        <Route path="briefings" element={<BriefingsPage />} />
        <Route path="punch-list" element={<PunchListPage />} />
        <Route path="tech-evals" element={<TechEvalsPage />} />
        <Route path="safe-review" element={<SafeReviewPage />} />
        <Route path="beta-feedback" element={<BetaFeedbackPage />} />
        <Route path="editor" element={<EditorPage />} />
        <Route path="audiobooks" element={<AudiobookPage />} />
        <Route path="voice-cloning" element={<VoiceCloningPage />} />
        <Route path="consciousness" element={<ConsciousnessPage />} />
        <Route path="settings" element={<SettingsPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
    </ThemeProvider>
  )
}

export default App
